import styled from 'styled-components'

import headerImage from '../images/head_img.jpg'
import icon from '../images/icons/calendar_lg_gold.png'
import logo from '../images/logo.png';


export const ModalHeading = styled.h4 `
text-align: center;
letter-spacing: 0px;
@media (min-width: 1200px) {
  margin-top: 25px;
  marign-bottom: 10px;
}
`
export const SpinnerWrapper = styled.div `
  top: ${props => props.size/2}px;
  position: relative;
  width: ${props => props.size}px;
  margin: 0 auto;
`
SpinnerWrapper.defaultProps = {
    size: 100
}

export const WappenLogo = styled.div `
   width:${props => props.size}px;
   height:${props => props.size}px;
   background:url(${logo}) center center no-repeat;
   background-size: ${props => props.size*0.9}px;
`
WappenLogo.defaultProps = {
    size: 100
}

export const CenterVertical = styled.div `
  height: 100%;
  width:100%;
  display:flex;
  align-items: center;
  justify-content: center;
`

export const Center = styled.div `
  text-align: center;
  margin: ${props => props.margin}px;
  margin-top: ${props => props.marginTop}px;
  margin-bottom: ${props => props.marginBottom}px;
`
Center.defaultProps = {
    marginTop: 0,
    marginBottom: 0,
    margin: 0
}

export const LightBackground = styled.div `
  background-color: #F5F5F5;
  overflow: hidden;
`

export const Grey = styled.p `
  color: grey
`

export const Red = styled.p `
  color: #d9534f
`

export const Black = styled.p `
  margin: 0px;
  color: black;
  font-weight: ${props => props.fontWeight};
  font-size: ${props => props.fontSize};
  display: ${props => props.display};
`
Black.defaultProps = {
    fontWeight: "normal",
    fontSize: "100%",
    display: "block",
}

export const Disclaimer = Black.extend `
  font-size: 8px;
`

export const Cancel = styled.p `
  margin: 0px;
  color: #d9534f;
`

export const GoldenLink = styled.a `
  opacity: 1;
  color: #DAB777;
  text-decoration: underline;
  font-weight: bold;
`

export const BlackHeading = styled.h4 `
  color: black;
  text-align: center;
  text-transform: uppercase;
`
export const BlackHeading1 = styled.h1 `
  color: black;
  text-align: center;
  text-transform: uppercase;
`

export const GoldHeading = styled.h4 `
  margin: 0px;
  margin-top: 20px;
  color: #DAB777;
`
export const NoBorderInput = styled.div `
  outline: none;
  border: 0px;
  box-shadow: none;
`
export const BorderLine = styled.div `
width: ${props => props.width};
border-bottom: 1px solid ${props => props.borderColor};
margin: 0 auto;
margin-top: 20px;
margin-bottom: 20px;
`
BorderLine.defaultProps = {
    width: "100%",
    borderColor: "#DEDEDE"
}

export const Icon = styled.div `
  margin: ${props => props.margin}px auto;
  float: ${props => props.float};
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  background: no-repeat url(${props => props.icon});
  background-size:     cover;
  background-position: center center;
  @media (max-width: 500px) {
    margin-right: -15px !important;
  }
`
Icon.defaultProps = {
    icon: icon,
    size: 32,
    margin: 0,
    float: "left"
}
export const IconBig = Icon.extend `
@media (max-width: 500px) {
  margin: ${props => props.margin}px auto !important;
}
`

export const HotelIcon = styled.div `
  margin: ${props => props.margin}px auto;
  float: ${props => props.float};
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  background: no-repeat url(${props => props.icon});
  background-size:     cover;
  background-position: center center;
`
HotelIcon.defaultProps = {
    icon: icon,
    size: 32,
    margin: 0,
    float: "left"
}

export const ImageSection = styled.div `
  @media (max-width: 768px) {
    height: ${props => props.tabletHeight}px;
  }
  filter: brightness(${props => props.brightness});
  height: ${props => props.height}px;
  width: 100%;
  background: ${ ({ background }) => background ? 'no-repeat url(' + background + ')' : 'lightgrey' };
  background-size:     cover;
  background-position: center center;
  opacity: ${props => props.opacity};
`
ImageSection.defaultProps = {
    background: headerImage,
    opacity: 1,
    height: 150,
    tabletHeight: 90,
    brightness: 1
}

export const NavSpacer = styled.div `
  margin-top: 60px;
`

export const MobileError = styled.div `
  max-height: 80px;
  overflow: hidden;
  padding: 25px;
  text-align: center;
  color: white;
  font-size: 14px;
  background-color: #d9534f;
`



export const LogeButton = styled.button `
  border: 1px solid;
  font-weight: 100;
  background: none;
  color: ${props => props.fontColor} !important;
  z-index: 99 !important;
  visibility: none;
  margin: 5px;
  text-align: center;
  border-radius: 6px !important;
  border-color: ${props => props.color} !important;
  letter-spacing: 1px !important;
  padding-left:15px!important;
  padding-right:15px!important;
  padding-top:10px!important;
  padding-bottom:10px!important;
  width:200px;
  transition: 0.3s;
  &:hover{
    transition: 0.3s;
    background-color: ${props => props.color} !important;
    color: ${props => props.hoverFontColor} !important;

  }
  &:active{
    background-color: ${props => props.color} !important;
    color: ${props => props.hoverFontColor} !important;

  }
  &:disabled {
    background: lightgrey;
    color: ${props => props.fontColor} !important;
  }
  &:disabled:hover {
    background: lightgrey !important;
    color: ${props => props.fontColor} !important;
  }

`
LogeButton.defaultProps = {
    color: "#DAB777",
    fontColor: "#DAB777"
}
export const LogeButtonFullWidth = LogeButton.extend `
  width: 100%;
`
export const LogeButtonSolid = LogeButton.extend `
  background-color: ${props => props.color} !important;

  &:hover {
    background-color: #FFFFFF00 !important;
  }
`

export const LogeButtonSlim = styled.button `
  border: 1px solid;
  font-weight: 300;
  font-size: 12px;
  color: ${props => props.fontColor} !important;
  z-index: 99 !important;
  visibility: none;
  margin: 5px;
  text-align: center;
  border-radius: 0px !important;
  border-color: ${props => props.color} !important;
  letter-spacing: 1px !important;
  padding: 10px 20px !important;
  transition: 0.3s;
  text-transform: uppercase;
  background: none;
  &:hover{
    transition: 0.3s;
    background-color: ${props => props.color} !important;
    color: ${props => props.hoverFontColor} !important;

  }
  &:active{
    background-color: ${props => props.color} !important;
    color: ${props => props.hoverFontColor} !important;

  }
  &:disabled, &:disabled:hover{
    transition: 0.3s;
    background-color: ${props => props.disabledColor} !important;
    color: ${props => props.disabledFontColor ? props.disabledFontColor : props.fontColor} !important;
    border: ${props => props.hideBorder ? "none" : "1px solid"}
  }

`

LogeButtonSlim.defaultProps = {
    color: "#DAB777",
    fontColor: "#DAB777",
    disabledColor: "#e6e6e6"
}

export const LodgeButtonLoadingRing = styled.div `
  position: absolute;
  display: block;
  width: 32px;
  height: 32px;
  left: 0;
  right: 0;
  top: 8px;
  margin-left: auto;
  margin-right: auto;
  transition: 0.3s;

  &:after {
    content: " ";
    display: block;
    width: 32px;
    height: 32px;
    margin: 1px;
    border-radius: 50%;
    border: 4px solid ${props => props.ringColor};
    border-color: ${props => props.ringColor} transparent ${props => props.ringColor} transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

`

LodgeButtonLoadingRing.defaultProps = {
  ringColor: "#DAB777",
}



// WEBPACK FOOTER //
// /src/components/GeneralStyle.js